/**
 * Which rail items print a section heading: a heading prints when the group changes from
 * the LAST ONE PRINTED.
 *
 * Equivalent to comparing with the previous item — but only while every item states its own
 * group, which is the point. The defect this replaces came from a second convention where
 * an item omitted `section` to mean "same group as above", so a later item repeating that
 * group reopened it and the practice rail printed "Manage" twice.
 *
 * Reach: [A, B, A] still prints A twice — contiguity is convention, ungated.
 * Pure and separate from NavList so the real nav lists can be fed to it in a test.
 */
export function sectionHeadings(
  items: readonly { readonly section?: string | undefined }[],
): Array<string | null> {
  let printed: string | undefined;
  return items.map((item) => {
    if (item.section == null || item.section === printed) return null;
    printed = item.section;
    return item.section;
  });
}
